module.exports = __webpack_public_path__ + "img/10_1.df21a8d7.png";